<template>
  <div>
    <el-row class="row">
      <el-col :span="24">
        <el-card class="row-card">
          <div slot="header" class="clearfix">
            <span class="title">应用桌面</span>
            <router-link
            :to="{
                name: 'appstore',
                params: {
                  marketID: storeDomain
                }
              }"
              style="float: right; padding: 3px 0"
              type="text"
              >浏览商店</router-link
            >
          </div>
          <div class="app-list" v-loading="appListLoading">
            <template v-if="appList && appList.length > 0">
              <div class="app-block" v-for="app in appList" :key="app.appID">
                <a v-if="app.domains" @click="handleDomain(app)">
                  <el-avatar
                    class="appLogo"
                    v-if="app.appLogo"
                    shape="square"
                    :size="80"
                    fit="fill"
                    :src="app.appLogo"
                  ></el-avatar>
                  <svg-icon
                    v-else
                    icon-class="app-default-icon"
                    class="defaultavatar appLogo"
                    shape="square"
                    :size="80"
                  ></svg-icon>
                  <span class="apptitle">{{ app.appName }}</span>
                </a>
              </div>
            </template>
            <no-data title="暂无应用" v-else></no-data>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="row" type="flex" justify="space-between">
      <el-col v-permit="'User.EntOrder.List'" :span="12">
        <el-card class="row-card">
          <div slot="header" class="clearfix">
            <span class="title">个人订单</span>
            <router-link
              :to="{ name: 'myorderAll', params: { orderState: 'all' } }"
              style="float: right; padding: 3px 0"
              type="text"
              >查看更多</router-link
            >
          </div>
          <div v-loading="orderOverviewLoading">
            <div class="statistical-container flex-box has-separation">
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-primary">
                    {{ orderOverview.newOrderNumMonth }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">月新订单</p>
                </div>
              </div>
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-primary">
                    {{ orderOverview.topayOrderNum }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">待付款订单</p>
                </div>
              </div>
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-primary">
                    {{ orderOverview.todeliveryOrderNum }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">待交付订单</p>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col v-permit="'User.WarningNotify.List'" :span="12">
        <el-card class="row-card">
          <div slot="header" class="clearfix">
            <span class="title">预警信息</span>
            <router-link
              :to="{ name: 'warningAlls' }"
              style="float: right; padding: 3px 0"
              type="text"
              >查看更多</router-link
            >
          </div>
          <div>
            <div class="statistical-container flex-box has-separation">
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-red">
                    {{ messageOverview.countNew }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">新预警</p>
                </div>
              </div>
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-primary">
                    {{ messageOverview.countFinish }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">已处理</p>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <MerchantsInfo
      v-if="isShowMerchantsInfo"
      @handleClose="
        isShowMerchantsInfo = false;
        appDetail = {};
      "
      :dialogVisible="isShowMerchantsInfo"
      :marketInfo="appDetail"
    />
  </div>
</template>

<script>
import { getOverviewAppList } from '@/api/delivery';
import { getOverviewAboutEnterpriseOrder } from '@/api/myOrder';
import { getUserOverviewAboutMessage } from '@/api/message';
import { errorHandle } from '@/utils/error';
import MerchantsInfo from '@/components/Dialog/MerchantsInfo/index.vue';
import { havePerm } from '@/utils/auth';
export default {
  name: 'Enterprise',
  components: {
    MerchantsInfo
  },
  data() {
    return {
      appDetail: {},
      storeDomain: JSON.parse(window.sessionStorage.getItem('storeDomain')),
      isShowMerchantsInfo: false,
      appListLoading: true,
      appList: [],
      messageOverviewLoading: true,
      messageOverview: {
        countNew: 0,
        countFinish: 0
      },
      orderOverview: {
        newOrderNumMonth: 0,
        topayOrderNum: 0,
        todeliveryOrderNum: 0,
        newConsumptionMonth: 0,
        newTopUpMonth: 0,
        balance: 0
      },
      orderOverviewLoading: true,
      deliveryOverview: {
        regionNum: 0,
        runningDeliveryAppNum: 0,
        deliveryAppNumMonth: 0
      },
      deliveryOverviewLoading: true
    };
  },
  computed: {
    marketID() {
      return this.$store.state.enterprise.enterpriseInfo.marketID;
    },
    creatorID() {
      return window.sessionStorage.getItem('creatorID');
    },
    userInfo() {
      return this.$store.state.user.userInfo;
    }
  },
  created() {
    this.getAppOverview();
    if (havePerm('User.EntOrder.List')) {
      this.getEnterpriseOrderOverview();
    }
    if (havePerm('User.WarningNotify.List')) {
      this.getMessageOverview();
    }
  },
  methods: {
    handleDomain(app) {
      if (app.canVisit) {
        window.open(app.domains[0], '_blank');
      } else {
        this.appDetail = app;
        this.isShowMerchantsInfo = true;
      }
    },
    getAppOverview() {
      getOverviewAppList({ marketID: this.marketID })
        .then((re) => {
          this.appList = re.apps;
          this.appListLoading = false;
        })
        .catch((err) => {
          errorHandle(err);
          this.appListLoading = false;
        });
    },
    getEnterpriseOrderOverview() {
      getOverviewAboutEnterpriseOrder({ creatorID: this.creatorID })
        .then((re) => {
          this.orderOverview = re;
          this.orderOverviewLoading = false;
        })
        .catch((err) => {
          errorHandle(err);
          this.orderOverviewLoading = false;
        });
    },
    getMessageOverview() {
      getUserOverviewAboutMessage({ userID: this.userInfo.userID })
        .then((re) => {
          this.messageOverview = re;
          this.messageOverviewLoading = false;
        })
        .catch((err) => {
          errorHandle(err);
          this.messageOverviewLoading = false;
        });
    }
  }
};
</script>

<style>
.title {
  border-left: 2px solid #3296fa;
  padding-left: 8px;
}
.row {
  margin-bottom: 16px;
}
.row-card {
  margin-left: 16px;
  min-height: 200px;
}
.app-list {
  overflow-x: auto;
  display: flex;
  flex-wrap: wrap;
}
.app-block {
  width: 112px;
  padding: 16px;
}
.app-block a {
  display: flex;
  flex-wrap: wrap;
}
.apptitle {
  text-align: center;
  width: 100%;
  display: block;
  margin-top: 4px;
}
.defaultavatar {
  width: 80px !important;
  height: 80px !important;
  padding: 8px;
}
.appLogo {
  border: 1px solid #f0f0f0;
  border-radius: 5px;
}
.el-loading-mask{
  z-index: 200;
}
</style>



// WEBPACK FOOTER //
// src/views/generalUser/myApp/components/enterprise.vue